var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAlternateIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 20",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".alt-icon-arrow-left{fill:#bcbec0;}"), /*#__PURE__*/React.createElement("style", null, ".alt-icon-arrow-right{fill:#284B9E;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  focusable: "false"
}, /*#__PURE__*/React.createElement("path", {
  className: "alt-icon-arrow-left",
  d: "M9,11.43c-.15-.21-.33-.44-.54-.67-.2-.22-.4-.41-.59-.57l-1.41,1.41c.93.85,1.54,1.54,1.54,3.4v5h2v-5c-.33-1.19-.67-2.38-1-3.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "alt-icon-arrow-right",
  d: "M8,15v5h2v-5c0-2.02.71-2.66,1.79-3.63,1.38-1.24,3.08-2.78,3.2-7.37h3.01L14,0l-4,4h2.99c-.06,2.04-.44,3.28-1,4.17-.15.24-.63.71-1.54,1.71-.67.62-1.35,1.38-1.45,1.55-.4.72-1,1.1-1,3.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "alt-icon-arrow-left",
  d: "M5.02,4h2.98L4,0,0,4h3.02c.02.81.08,1.54.19,2.17l1.94-.49c-.07-.48-.12-1.05-.13-1.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "alt-icon-arrow-left",
  d: "M5.51,7.15l-1.94.49c.45,1.36,1.11,2.25,1.79,2.94l1.42-1.42c-.5-.51-.95-1.12-1.27-2.01Z"
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlternateIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alternateIcon.9a61d451.svg";
export { ForwardRef as ReactComponent };